import { Box } from "@mui/material";
import { Skeleton } from "@mui/material";
import { times } from "lodash-es";

interface Props {}

export function LegendLoading(props: Props) {
  // render the component
  return render();

  function render() {
    return (
      <Box pb={1}>
        {times(10, (i) => (
          <Box pb={1} key={i}>
            <Skeleton variant="rectangular" width="100%" height={15} />
          </Box>
        ))}
      </Box>
    );
  }
}
